import React, {useEffect, useState} from "react";
import {apiClient} from "../../../../../services/ApiClient";
import {
  DatePicker,
  message,
  Space,
  Table
} from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

export default function SupplyHoursTab({driver, active}) {

  let [loading, setLoading] = useState(false);
  let [records, setRecords] = useState([]);
  let [update, setUpdate] = useState(0);
  let [periodTotal, setPeriodTotal] = useState(0);
  let [periodPlan, setPeriodPlan] = useState(0);
  let [filters, setFilters] = useState({});

  useEffect(() => {
    if(driver && driver.id > 0 && active) {
      setLoading(true);
      apiClient.getDriverDayOrders(driver.id, filters)
        .then(res => {
          setRecords(res.records);
          let total = 0;
          let plan = 0;
          res.records.forEach((el, i) => {
            total += el.total_count;
            plan += el.day_count_min;
          });
          setPeriodTotal(total);
          setPeriodPlan(plan);
        })
        .catch(err => message.error(err))
        .finally(() => setLoading(false));
    } else {
      setRecords([]);
    }
  }, [driver, active, update, filters]);

  return (
    <>
      <div style={{marginBottom: 16}}>
        <Space style={{float: "right", marginBottom: 8}} direction="horizontal">
          <span>
            Сумма план/факт: {periodPlan} / {periodTotal}
          </span>
          <RangePicker
            showTime={false}
            format="DD.MM.YYYY"
            style={{width: 350}}
            onChange={(dates) => setFilters({...filters, fromDate: dates ? dates[0].format("YYYY-MM-DD") : null, toDate: dates ? dates[1].format("YYYY-MM-DD") : null})}
          />
        </Space>
      </div>
      <Table
        loading={loading}
        scroll={{x: 1000}}
        sticky
        columns={[
          {
            title: "",
            align: "center",
            width: 30,
          },
          {
            title: 'Дата',
            defaultSortOrder: "descend",
            render: (text, record, index) => {
              return `${moment(record.day_dt).format('DD.MM.YYYY')}`;
            }
          },
          {
            title: 'План (заказов)',
            render: (text, record, index) => {
              return record.day_count_min;
            }
          },
          {
            title: 'Факт (заказов)',
            render: (text, record, index) => {
              return record.total_count;
            }
          },
          {
            title: 'Сумма списания',
            render: (text, record, index) => {
              return record.day_penalty_amount;
            }
          },
          {
            title: "",
            align: "center",
            width: 20,
          }
        ]}
        dataSource={records}
        rowKey="id"
      />
    </>
  )
}